// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__6RwJf","text":"Contact_text__9d48B","map":"Contact_map__HPoEk","contact-info":"Contact_contact-info__Dgny-","slideChange":"Contact_slideChange__uPfRt"};